import { createTheme } from "@mui/material/styles";

const portalTheme = createTheme({
  palette: {
    secondary: {
      main: "#efeeee",
      contrastText: "#000000",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        outlinedSecondary: {
          color: "#000",
          backgroundColor: "#efeeee",
          borderColor: "#e0e0e0",
          textTransform: "none",
          fontSize: "0.875rem",
        },
        containedSecondary: {
          backgroundColor: "#efeeee",
          color: "#000",
          "&:hover": {
            backgroundColor: "#e0e0e0",
          },
        },
      },
    },
  },
});

export default portalTheme;
